import api from './api';

export const memberService = {
  // Get all members with pagination and filters

  // Generate auto-login link
  generateAutoLoginLink: async (id) => {
    const response = await api.post(`/admin/members/${id}/auto-login`);
    return response.data;
  },


  getMembers: async (params = {}) => {
    const response = await api.get('/admin/members', { params });
    return response.data;
  },

  // Get single member
  getMember: async (id) => {
    const response = await api.get(`/admin/members/${id}`);
    return response.data;
  },

  // Create new member
  createMember: async (memberData) => {
    const response = await api.post('/admin/members', memberData);
    return response.data;
  },

  // Update member
  updateMember: async (id, memberData) => {
    const response = await api.put(`/admin/members/${id}`, memberData);
    return response.data;
  },

  // Delete member
  deleteMember: async (id) => {
    const response = await api.delete(`/admin/members/${id}`);
    return response.data;
  },

  // Assign batch to member
  assignBatch: async (id, assignmentData) => {
    const response = await api.post(`/admin/members/${id}/assign-batch`, assignmentData);
    return response.data;
  },

  // Get member statistics
  getStats: async () => {
    const response = await api.get('/admin/members/stats');
    return response.data;
  }


};